import menuIndex from '../../pages/menu'

const MenuRoute = [
  {
    path: '/menu',
    name: 'menu',
    component: menuIndex
  }
]
export default MenuRoute



// WEBPACK FOOTER //
// ./src/router/menu/index.js